// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../components/shared/Util.re.mjs";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__Array from "@rescript/core/src/Core__Array.re.mjs";

function getAvg(point) {
  return Core__Array.reduce(point, 0, (function (acc, value) {
                return acc + value;
              })) / point.length;
}

var DataPoint = {
  getAvg: getAvg
};

function make(t) {
  return Util.NonEmptyArray.fromArray(t.toSorted(function (a, b) {
                  var clusterA = a.centroid;
                  var clusterB = b.centroid;
                  if (Caml_obj.lessthan(clusterA, clusterB)) {
                    return 1;
                  } else {
                    return -1;
                  }
                }));
}

var SortedClusters = {
  make: make
};

function getMinMax(cluster) {
  var min = Core__Array.reduce(cluster.points, 100, (function (acc, pt) {
          if (acc < getAvg(pt)) {
            return acc;
          } else {
            return getAvg(pt);
          }
        }));
  var max = Core__Array.reduce(cluster.points, 0, (function (acc, pt) {
          if (acc > getAvg(pt)) {
            return acc;
          } else {
            return getAvg(pt);
          }
        }));
  return [
          min,
          max
        ];
}

var ClusterResult = {
  getMinMax: getMinMax
};

export {
  DataPoint ,
  SortedClusters ,
  ClusterResult ,
}
/* No side effect */
